/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import React,{FC,useState, useEffect, useCallback} from "react";
import {FormState} from "../survey/SurveyModel/types/commonTypes";
import Errors from "./Error";
import debounce from "lodash/debounce";
interface ITextArea {
name: string
onChange: (text: string, name:string)=> void
value: string
propClasses: string
disabled?: boolean
onBlur?:()=> void
isInValid: boolean
propDivClasses?: string
form: FormState
}

const TextArea:FC<ITextArea> = (props: ITextArea) => {
  const { name, onChange, value, propClasses, onBlur, disabled, isInValid, propDivClasses="textarea-width", form } = props;

  const [isFocused, setIsFocused] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const debouncedOnChange = useCallback(
    debounce((text: string, fieldName: string) => {
      onChange(text, fieldName);
    }, 500),
    []
  );

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setLocalValue(value);
    debouncedOnChange(value, name);
  };

    const handleOnBlur = ()=> {
      setIsFocused(false)
      if(onBlur){
        onBlur();
      }

    }
      
    return (
            <div className={`${isInValid ? 'error': ''} ${propDivClasses}`}>
            <div className={ `input-div ${isFocused ? 'input-div-focus' : ''} ${isActive ? 'input-div-active' : ''} ${disabled ? 'disabled':''}`}>
            <textarea 
              className={propClasses}
              onChange={handleChange}
              value={localValue}
              onBlur={handleOnBlur}
              onFocus={() => setIsFocused(true)}
              disabled={disabled}
              onMouseDown={() => setIsActive(true)}
              onMouseUp={() => setIsActive(false)}
            />
            </div>
            {form ?<Errors fieldName={name} validation={form[name] ? form[name] : undefined}/> : '' }
            </div>
          )

};

export default TextArea;